import type { Role } from '@clan-heart/shared';
import styles from './RoleBadge.module.css';

const LABELS: Record<Role, string> = {
  owner: 'owner',
  first_officer: 'First officer',
  officer: 'officer',
  member: 'member',
};

export function RoleBadge({ role }: { role: Role }) {
  return <span className={`${styles.badge} ${styles[role]}`}>{LABELS[role]}</span>;
}
